import { Component, OnInit } from '@angular/core';
import { RutasService } from '../../../../services/rutas.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Helper } from '../../../../helpers/helper';
import { AlertasModales } from '../../../../helpers/alertasModales';
import { EmpleadosServicio } from '../../../../services/empleado.service';

@Component({
  selector: 'app-detalle-ruta',
  templateUrl: './detalle-ruta.component.html',
  styleUrls: ['./detalle-ruta.component.css']
})
export class DetalleRutaComponent implements OnInit {
  // google maps zoom level
  zoom = 8;
  lat = 18.6691759;
  lng = -71.2512628;
  markers: any[] = [];
  ruta: any;
  urlImg;
  constructor(
    private route: ActivatedRoute,
    private rutaService: RutasService,
    private router: Router,
    private helper: Helper,
    public empleadoService: EmpleadosServicio,
    private modals: AlertasModales) {
    this.urlImg = this.helper.urlImg + 'cedulas';
    this.detalleRuta();
  }

  ngOnInit() {
  }

  // Cargar detalle de la ruta por su ID
  detalleRuta() {
    this.route.params.subscribe(res => {
      if (res) {
        this.rutaService.detalleRuta(res.ID_RUTA).subscribe((data: any) => {
          if (data) {
            this.ruta = data;
            this.markers = data.clientes;
          } else {
            this.router.navigate(['/404']);
          }
        });
      }
    });
  }

  importarClientes() {
    if (this.ruta) {
      this.modals.importarClientesRutaNgbModal(this.ruta.ID_RUTA)
      .then(res => {
        if (res) {
          if (res === 'OK') {
            this.modals.validacionesModalJquery('Cliente(s) movido(s) con éxito', '', 'green', 'modern', false, 'fa fa-user');
          }
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/rutas/detalle/detalle-ruta/detalle-ruta.component.ts